interface INonCertifiedTrader {
    sellerNonCertifiedTraderName: string;
    sellerNonCertifiedTraderTeId: string;
    additionalProp1: Record<string, any>;
}

interface IBuyerDetails {
    buyerLicenseNo: string;
    isBuyerTeCertified: string;
    buyingOnBehalfOfFlag: string;
    buyerName: string;
    buyerTeId: string;
    buyerAddress1: string;
    buyerAddress2: string;
    buyerAddress3: string;
    buyerPostcode: string;
    buyerTown: string;
    buyerStateOrProvince: string;
    buyerCountryOrArea: string;
    buyerCertifiedOrganizationName: string;
    receiverRole: string;
    additionalProp1: Record<string, any>;
}

interface ISellerDetails {
    sellerLicenseNo: string;
    sellingOnBehalfOfFlag: string;
    sellerName: string;
    sellerTeId: string;
    sellerAddress1: string;
    sellerAddress2: string;
    sellerAddress3: string;
    sellerPostcode: string;
    sellerTown: string;
    sellerStateOrProvince: string;
    sellerCountryOrArea: string;
    sellerCertifiedOrganizationName: string;
    sellerScNo: string[];
    senderRole: string;
    sellerNonCertifiedTraderName: string;
    sellerNonCertifiedTraderTEId: string;
    additionalProp1: Record<string, any>;
}

interface IBuyerSellerData {
    nonCertifiedTrader: any;
    etcId: string;
    buyerDetails: IBuyerDetails;
    sellerDetails: ISellerDetails;
    // nonCertifiedTrader: INonCertifiedTrader[];
    additionalProp1: Record<string, any>;
}
  
export const iBuyerSellerModel: IBuyerSellerData = {
    etcId: "",
    buyerDetails: {
        buyerLicenseNo: "",
        isBuyerTeCertified: "",
        buyingOnBehalfOfFlag: "",
        buyerName: "",
        buyerTeId: "",
        buyerAddress1: "",
        buyerAddress2: "",
        buyerAddress3: "",
        buyerPostcode: "",
        buyerTown: "",
        buyerStateOrProvince: "",
        buyerCountryOrArea: "",
        buyerCertifiedOrganizationName: "",
        receiverRole: "",
        additionalProp1: {},
    },
    sellerDetails: {
        sellerLicenseNo: "",
        sellingOnBehalfOfFlag: "",
        sellerScNo: [],
        sellerName: "",
        sellerTeId: "",
        sellerAddress1: "",
        sellerAddress2: "",
        sellerAddress3: "",
        sellerPostcode: "",
        sellerTown: "",
        sellerStateOrProvince: "",
        sellerCountryOrArea: "",
        sellerCertifiedOrganizationName: "",
        senderRole: "",
        additionalProp1: {},
        sellerNonCertifiedTraderName: "",
        sellerNonCertifiedTraderTEId: ""
    },
    // nonCertifiedTrader: [],
    additionalProp1: {},
    nonCertifiedTrader: undefined
};

export const mapJsonToBuyerSellerModel = (json: IBuyerSellerData): IBuyerSellerData => {
    return {
        etcId: json.etcId,
        buyerDetails: {
            buyerLicenseNo: json.buyerDetails.buyerLicenseNo,
            isBuyerTeCertified: json.buyerDetails.isBuyerTeCertified,
            buyingOnBehalfOfFlag: json.buyerDetails.buyingOnBehalfOfFlag,
            buyerName: json.buyerDetails.buyerName,
            buyerTeId: json.buyerDetails.buyerTeId,
            buyerAddress1: json.buyerDetails.buyerAddress1,
            buyerAddress2: json.buyerDetails.buyerAddress2,
            buyerAddress3: json.buyerDetails.buyerAddress3,
            buyerPostcode: json.buyerDetails.buyerPostcode,
            buyerTown: json.buyerDetails.buyerTown,
            buyerStateOrProvince: json.buyerDetails.buyerStateOrProvince,
            buyerCountryOrArea: json.buyerDetails.buyerCountryOrArea,
            buyerCertifiedOrganizationName: json.buyerDetails.buyerCertifiedOrganizationName,
            receiverRole: json.buyerDetails.receiverRole,
            additionalProp1: {},
        },
        sellerDetails: {
            sellerLicenseNo: json.sellerDetails.sellerLicenseNo,
            sellingOnBehalfOfFlag: json.sellerDetails.sellingOnBehalfOfFlag === 'Y'?"Yes":"No",
            sellerScNo: json.sellerDetails.sellerScNo,
            sellerName: json.sellerDetails.sellerName,
            sellerTeId: json.sellerDetails.sellerTeId,
            sellerAddress1: json.sellerDetails.sellerAddress1,
            sellerAddress2: json.sellerDetails.sellerAddress2,
            sellerAddress3: json.sellerDetails.sellerAddress3,
            sellerPostcode: json.sellerDetails.sellerPostcode,
            sellerTown: json.sellerDetails.sellerTown,
            sellerStateOrProvince: json.sellerDetails.sellerStateOrProvince,
            sellerCountryOrArea: json.sellerDetails.sellerCountryOrArea,
            sellerCertifiedOrganizationName: json.sellerDetails.sellerCertifiedOrganizationName,
            senderRole: json.sellerDetails.senderRole,
            sellerNonCertifiedTraderName: json.nonCertifiedTrader[0].sellerNonCertifiedTraderName,
            sellerNonCertifiedTraderTEId: json.nonCertifiedTrader[0].sellerNonCertifiedTraderTeId,
            additionalProp1: {},
        },
        nonCertifiedTrader: json.nonCertifiedTrader,
        additionalProp1: json.additionalProp1,
    };
};

export const mapPayload = (jsonData: any, etcId: any) => {
    return {
        etcId: etcId,
        buyerDetails: {
            buyerLicenseNumber: jsonData.buyerLicenseNumber,
            isBuyerTeCertified: jsonData.isBuyerTeCertified,
            buyingOnBehalfOfFlag: jsonData.buyingOnBehalfOfFlag,
            buyerName: jsonData.buyerName,
            buyerTeId: jsonData.buyerTEId,
            buyerAddress1: jsonData.buyerAddress1,
            buyerAddress2: jsonData.buyerAddress2,
            buyerAddress3: jsonData.buyerAddress3,
            buyerPostcode: jsonData.buyerPostcode,
            buyerTown: jsonData.buyerTown,
            buyerStateOrProvince: jsonData.buyerStateOrProvince,
            buyerCountryOrArea: jsonData.buyerCountryOrArea,
            buyerCertifiedOrganizationName: jsonData.buyerCertifiedOrganizationName,
            receiverRole: jsonData.receiverRole,
        },
        sellerDetails: {
            sellerLicenseNo: jsonData.sellerLicenseNumber,
            sellingOnBehalfOfFlag: jsonData.sellingOnBehalfOfFlag,
            sellerNonCertifiedTraderName: jsonData.sellerNonCertifiedTraderName,
            sellerNonCertifiedTraderTEId: jsonData.sellerNonCertifiedTraderTEId,
            sellerScNo: jsonData.sellerScNo,
            sellerName: jsonData.sellerName,
            sellerTeId: jsonData.sellerTEId,
            sellerAddress1: jsonData.sellerAddress1,
            sellerAddress2: jsonData.sellerAddress2,
            sellerAddress3: jsonData.sellerAddress3,
            sellerPostcode: jsonData.sellerPostcode,
            sellerTown: jsonData.sellerTown,
            sellerStateOrProvince: jsonData.sellerStateOrProvince,
            sellerCountryOrArea: jsonData.sellerCountryOrArea,
            sellerCertifiedOrganizationName: jsonData.sellerCertifiedOrganizationName,
            senderRole: jsonData.senderRole,
        },
        nonCertifiedTrader: [
            {
                sellerNonCertifiedTraderName: jsonData.sellerNonCertifiedTraderName,
                sellerNonCertifiedTraderTeId: jsonData.sellerNonCertifiedTraderTEId,
                additionalProp1: {},
            },
        ],
        additionalProp1: {},
    };
}